// external dependencies
import React from 'react'
import { bool, string } from 'prop-types'
import styled from '@emotion/styled'

// styled components
const TabWrap = styled.div`
	background-color: transparent;
	display: inline;
	height: 32px;
	margin-left: 0;
	margin-right: ${({ isLastTab }) => isLastTab && '32px'};
`

const TabLabelContainer = styled.div`
	border-bottom-style: solid;
	border-color: ${({ isActiveTab, theme }) => (isActiveTab ? theme.colors.orange : 'transparent')};
	border-width: 0.3125rem;
	color: ${({ isActive, theme }) => (isActive ? theme.colors.text : theme.colors.darkGrey)};
	display: inline-block;
	font-size: 16px;
	font-weight: 700;
	margin: 0 5px;
	padding: 0 20px 5px 20px;
	text-transform: capitalize;
	transition: 0.2s ease border-color;

	${({ theme }) => theme.MQ.S} {
		font-size: 14px;
	}

	&:hover {
		color: ${({ theme }) => theme.colors.text};
		cursor: pointer;
		border-color: ${({ isActive, theme }) => !isActive && theme.colors.teal};
	}
`

Tab.propTypes = {
	areTabsDisabled: bool.isRequired,
	displayArrow: bool,
	isActive: bool.isRequired,
	isLastTab: bool.isRequired,
	label: string.isRequired,
}

export function Tab({ displayArrow, isActive = false, isLastTab, label, areTabsDisabled }) {
	return (
		<TabWrap isLastTab={isLastTab}>
			<TabLabelContainer isActiveTab={isActive}>{label}</TabLabelContainer>
		</TabWrap>
	)
}
